import React from 'react';
import './Button.css';

/**
 * 버튼 규칙 (DESIGN.md › Buttons)
 * - 화면마다 primary는 하나만.
 * - danger는 테두리형이 기본, 확정된 파괴 동작에만 danger-solid.
 * - 라벨은 구체적으로: "SAA-C03 시험 시작" (O) / "시작" (X)
 */
export type ButtonVariant = 'primary' | 'secondary' | 'tertiary' | 'danger' | 'danger-solid';
type LegacyVariant = 'outline-primary' | 'outline-secondary' | 'light';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant | LegacyVariant;
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
  loading?: boolean;
  icon?: React.ReactNode;
  iconPosition?: 'left' | 'right';
}

const LEGACY: Record<LegacyVariant, ButtonVariant> = {
  'outline-primary': 'tertiary',
  'outline-secondary': 'secondary',
  light: 'secondary',
};

const Button: React.FC<ButtonProps> = ({
  children,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  loading = false,
  icon,
  iconPosition = 'left',
  className = '',
  disabled,
  type = 'button',
  ...props
}) => {
  const v = (LEGACY as Record<string, ButtonVariant>)[variant] ?? variant;
  const classes = [
    'ui-btn',
    `ui-btn--${v}`,
    `ui-btn--${size}`,
    fullWidth && 'ui-btn--block',
    loading && 'ui-btn--loading',
    className,
  ].filter(Boolean).join(' ');

  return (
    <button type={type} className={classes} disabled={disabled || loading} aria-busy={loading || undefined} {...props}>
      {loading && <span className="ui-btn__spinner" aria-hidden="true" />}
      {!loading && icon && iconPosition === 'left' && <span className="ui-btn__icon">{icon}</span>}
      {children && <span className="ui-btn__label">{children}</span>}
      {!loading && icon && iconPosition === 'right' && <span className="ui-btn__icon">{icon}</span>}
    </button>
  );
};

export default Button;